import { createSvgIcon } from '@mui/material';

export const CallendarCancelledIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none">
    <path
      d="M12.6499 6.19771H1.25M9.48326 0.986328V3.59202M4.41664 0.986328V3.59202M5.60412 11.501L8.4541 8.56957M5.60412 8.56957L8.4541 11.501M4.28997 14.0148H9.60993C10.674 14.0148 11.2061 14.0148 11.6125 13.8018C11.97 13.6144 12.2607 13.3155 12.4428 12.9477C12.6499 12.5297 12.6499 11.9825 12.6499 10.888V5.416C12.6499 4.32151 12.6499 3.77426 12.4428 3.35622C12.2607 2.9885 11.97 2.68954 11.6125 2.50218C11.2061 2.28917 10.674 2.28917 9.60993 2.28917H4.28997C3.22588 2.28917 2.69384 2.28917 2.28741 2.50218C1.9299 2.68954 1.63924 2.9885 1.45709 3.35622C1.25 3.77426 1.25 4.32151 1.25 5.416V10.888C1.25 11.9825 1.25 12.5297 1.45709 12.9477C1.63924 13.3155 1.9299 13.6144 2.28741 13.8018C2.69384 14.0148 3.22588 14.0148 4.28997 14.0148Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>,
  'CallendarCancel',
);
